(function ($) {
    var $ = jQuery = $;
    $(document).ready(function () {


        $(document).on("click", ".slick-arrow", function () {
            $(this).closest(".index-section--hero").find(".slick-active").focus();
        })
        $(document).on("click", ".slick-dots button", function () {
            $(this).closest(".index-section--hero").find(".slick-active").focus();
        })
        $(".js-drawer-open-cart").on("click", function () {
            $("#CartDrawer").focus();
        })
        //Load Accordions
        let arrowMarkup = '<span class="collapsible-trigger__icon collapsible-trigger__icon--open" role="img" aria-label="content collapsible button">\n' +
            '  <svg aria-hidden="true" focusable="false" role="img" aria-label="content collapsible button" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="M1.57 1.59l12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none" fill-rule="evenodd"></path></svg>\n' +
            '</span>';
        let allAccordionButtons = $('button.accordion');
        $(allAccordionButtons).each(function () {
            $(this).append(arrowMarkup);
        });
        let allPanels = $('.accordion + div').hide();


        $('.accordion').click(function () {


            if (!$(this).next().is(':visible')) {
                $(allAccordionButtons).removeClass("on");
                $(this).addClass("on");
//                 allPanels.slideUp();
                $(this).next().slideDown();
            } else {
                $(allAccordionButtons).removeClass("on");
                $(this).next().slideUp();
            }

            return false;
        });
//         $(allAccordionButtons).eq(0).addClass("on").next().show();


        $(".collection-header-slider").slick({
            centerMode: false,
            dots: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            focusOnSelect: true,
            autoplay: true,
            autoplaySpeed: 6000,
            fade: true
        });


        $('.logo__blocks').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            asNavFor: '.logo-bar',
            fade: true
        });
        let logo_list_bars = $(".logo-bar");
        $(logo_list_bars).slick({
            centerMode: false,
            dots: false,
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            focusOnSelect: true,
            asNavFor: '.logo__blocks',
            autoplay: $(logo_list_bars).data('autoplay'),
            autoplaySpeed: 10000,
            responsive: [
                {
                    breakpoint: 900,
                    settings: {
                        arrows: true,
                        centerMode: true,
                        centerPadding: '50px',
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '50px',
                        slidesToShow: 2
                    }
                }
            ]
        });
        $(logo_list_bars).find(".logo-bar__item").on("click", function () {
            console.log("logo click");
            $(this).closest(".shopify-section").find(".logo__blocks .slick-active").focus();
        })
        let product_thumbs = $("body.template-product .product__thumbs");
        let product_main_photos = $("body.template-product .product__main-photos");

        if (product_thumbs.length > 0) {
            setTimeout(function () {
                let slick_container = product_thumbs.find(".slick-track");
                if (slick_container.height() < product_main_photos.height()) {
                    slick_container.addClass("fix-on-top");
                    console.log(slick_container.height() + "-" + product_main_photos.height());
                }

            }, 1000);

        }
        $(".mobile-menu").on("click", function () {
            $(this).toggleClass("on");
        })
        $(".account-order-row").on("click", function () {
            window.location.href = $(this).data("href");
        })

        $(document).on("click", "#addresses-page", function () {
            window.location.href = "/account/addresses";
            return false;
        });


        function isOnScreen(elem) {
            // if the element doesn't exist, abort
            if (elem.length === 0) {
                return;
            }
            let $window = jQuery(window)
            let viewport_top = $window.scrollTop()
            let viewport_height = $window.height()
            let viewport_bottom = viewport_top + viewport_height
            let $elem = jQuery(elem)
            let top = $elem.offset().top
            let height = $elem.height()
            let bottom = top + height

            return (top >= viewport_top && top < viewport_bottom) ||
                (bottom > viewport_top && bottom <= viewport_bottom) ||
                (height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
        }

        let home_slider_on_screen = false;
        let home_slider_element = $("#Slideshow-1593716533024");
        if (home_slider_element.length > 0) {
            $(window).scroll(function () {
                if (!home_slider_on_screen) {
                    if (isOnScreen(home_slider_element)) {
                        home_slider_on_screen = true;
                        $(home_slider_element).addClass("aos-animate");
                    }
                }

            });
        }

        function ifExists(content,contentToFind ){

            //Find in the String
            var result = result = (content.indexOf(contentToFind) > -1) ? true : false;
            //Print result
            return result;

        }
        // gets all <li> within #menu element
        var menuli = document.getElementById('header-split-logo-menu').getElementsByClassName('site-nav__item');
        var nrmenuli = menuli.length;

        var oli = [];        // store horisontal menu items
        var crt_oli;         // store current horisontal element
        var vli = [];        // store vertical menu list in within current horisontal element
        var nroli = 0;       // number of horisontal menu items
        var nrvli = 0;       // number of vertical menu lists
        var url_adr = '';    // store the URL address added in the anchor <a> of current navigated list

// traverse $menuli to add the horisontal menus in $oli
        for (var i = 0; i < nrmenuli; i++) {
            oli.push(menuli[i]);
        }

        var ih = -1;     // to store the index of current horizontal item in $oli
        var iv = -1;    // to store the index of current vertical item in $vli

// accessed on press the Left /Right arrow keys
// show current horisontal menu
        function showOli(index) {
            iv = -1;       // reset imdex of vertical menu when moves to other horisontal menu
            url_adr = '';     // empty this variable

            for (var i = 0; i < nroli; i++) {
                oli[i].className = oli[i].className.replace("is-focused", "");
                if (!ifExists(oli[i].className,'oli')) oli[i].className = oli[i].className+' oli';
            }
            crt_oli = oli[index];     // store current horisontal element
            crt_oli.className =  crt_oli.className+' is-focused';      // set class="olishow"
            crt_oli.focus()

            // if current horisontal menu contains vertical menu, store it in $vli, and display it
            if (crt_oli.getElementsByTagName('ul').length > 0 && crt_oli.getElementsByTagName('ul')[0].getElementsByTagName('li')) {
                vli = crt_oli.getElementsByTagName('ul')[0].getElementsByTagName('li');

                nrvli = vli.length;

                showVli();     // calls showVli() to set class="vli" to all list in its vertical menu
            } else {
                // if current horisontal menu no has vertical list
                // if contains a link, calls the function setUrlAdr() to add its "href" value in $url_adr
                if (crt_oli.getElementsByTagName('a').length > 0) setUrlAdr(crt_oli.getElementsByTagName('a')[0]);
                vli = [];        // empties $vli
                nrvli = 0;
            }
        }

// accessed on press the Up /Down arrow keys
// show current vertical menu
        function showVli(index) {
            url_adr = '';       // empties this variable
            if (nrvli > 0) {
                for (var i = 0; i < nrvli; i++) {
                    vli[i].className = vli[i].className.replace("vlishow", "");
                    if (!ifExists(vli[i].className,'vli')) vli[i].className = vli[i].className+' vli';
                }
                if (index >= 0) {
                    vli[index].className = vli[index].className+' vlishow';
                    vli[index].getElementsByTagName('a')[0].focus();
                    // if contains a link, calls the function setUrlAdr() to add its "href" value in $url_adr
                    if (vli[index].getElementsByTagName('a').length > 0) setUrlAdr(vli[index].getElementsByTagName('a')[0]);
                }
            }
        }

// adds in $url_adr the "href" value of the anchor element <a> passed in "link" parameter
        function setUrlAdr(link) {
            url_adr = link.href;
        }

// function with code to get the pressed keyboard key
        function KeyCheck(e) {
            // https://coursesweb.net/
            nroli = oli.length;
            var keyid = (window.event) ? event.keyCode : e.keyCode;       // get the code of the key pressed

            // modify the index of horisontal /vertical item, calls the indicated function according to pressed key
            switch (keyid) {
                // Left
                case 37:
                    ih--;
                    if (ih < 0) ih = 0;
                    showOli(ih);
                    break;
                // Up
                case 38:
                    iv--;
                    if (iv < 0) iv = 0;
                    showVli(iv);
                    break;
                // Right
                case 39:
                    ih++;
                    if (ih >= nroli) ih = 0;
                    showOli(ih);
                    break;
                // Down
                case 40:
                    iv++;
                    if (iv >= nrvli) iv = 0;
                    showVli(iv);
                    break;
                // Enter (opens the link)
                case 13:
                    if (url_adr !== '') window.location = url_adr;
                    break;
            }
        }

// access the KeyCheck() function when a keyboard button is pressed
        document.onkeydown = KeyCheck;
    });
})(theme.jQuery);